import { MapIconConfig } from './map.model';

const SELECTED_MARKER_SCALE = 1.5;

export type MapIconConfigs = {
    [K in keyof typeof SizeValuesMap]: MapIconConfig;
};

export enum IconSizeEnum {
    small = 's',
    medium = 'm',
    large = 'l'
}
export enum IconSizeOrderEnum {
    s = 0,
    m = 1,
    l = 2
}
export enum ZoomBreakPointsEnum {
    s = 12,
    m = 15
}
export enum StopIconSizesEnum {
    s = 3,
    m = 16,
    l = 32
}

export enum FavoriteIconSizesEnum {
    s = 3,
    m = 32,
    l = 32
}
export enum LocationsIconSizesEnum {
    s = 12,
    m = 24,
    l = 24
}
export enum BusIconSizesEnum {
    s = 0,
    m = 16,
    l = 32
}
export enum StopNodesIconSizesEnum {
    s = 0,
    m = 10,
    l = 14
}
export class IconUtils {
    static getStopIconSizeValues(mapZoom: number): number {
        if (mapZoom > ZoomBreakPointsEnum.s && mapZoom < ZoomBreakPointsEnum.m) {
            return StopIconSizesEnum.m;
        } else if (mapZoom >= ZoomBreakPointsEnum.m) {
            return StopIconSizesEnum.l;
        } else if (mapZoom <= ZoomBreakPointsEnum.s) {
            return StopIconSizesEnum.s;
        }
    }
    static getFavoriteStopIconSizeValues(mapZoom: number): number {
        if (mapZoom > ZoomBreakPointsEnum.s && mapZoom < ZoomBreakPointsEnum.m) {
            return FavoriteIconSizesEnum.m;
        } else if (mapZoom >= ZoomBreakPointsEnum.m) {
            return FavoriteIconSizesEnum.l;
        } else if (mapZoom <= ZoomBreakPointsEnum.s) {
            return FavoriteIconSizesEnum.s;
        }
    }

    static getLocationIconSizeValues(mapZoom: number): number {
        if (mapZoom > ZoomBreakPointsEnum.s && mapZoom < ZoomBreakPointsEnum.m) {
            return LocationsIconSizesEnum.m;
        } else if (mapZoom >= ZoomBreakPointsEnum.m) {
            return LocationsIconSizesEnum.l;
        } else if (mapZoom <= ZoomBreakPointsEnum.s) {
            return LocationsIconSizesEnum.s;
        }
    }
    static getBusIconSizeValues(mapZoom: number): number {
        if (mapZoom > ZoomBreakPointsEnum.s && mapZoom < ZoomBreakPointsEnum.m) {
            return BusIconSizesEnum.m;
        } else if (mapZoom >= ZoomBreakPointsEnum.m) {
            return BusIconSizesEnum.l;
        } else if (mapZoom <= ZoomBreakPointsEnum.s) {
            return BusIconSizesEnum.s;
        }
    }
    static getStopNodeIconSizeValues(mapZoom: number): number {
        if (mapZoom > ZoomBreakPointsEnum.s && mapZoom < ZoomBreakPointsEnum.m) {
            return StopNodesIconSizesEnum.m;
        } else if (mapZoom >= ZoomBreakPointsEnum.m) {
            return StopNodesIconSizesEnum.l;
        } else if (mapZoom <= ZoomBreakPointsEnum.s) {
            return StopNodesIconSizesEnum.s;
        }
    }
    static getIconSize(mapZoom: number): IconSizeEnum {
        if (mapZoom > ZoomBreakPointsEnum.s && mapZoom < ZoomBreakPointsEnum.m) {
            return IconSizeEnum.medium;
        } else if (mapZoom >= ZoomBreakPointsEnum.m) {
            return IconSizeEnum.large;
        } else if (mapZoom <= ZoomBreakPointsEnum.s) {
            return IconSizeEnum.small;
        }
    }

    static calculateMapIconsSize(zoom: number, isFavoriteStop = false): MapIconConfigs {
        return Object.keys(SizeValuesMap).reduce((acc, type) => {
            const calculateSize = SizeValuesMap[type];
            const size = type === MarkerType.stopSelected ? calculateSize(zoom, isFavoriteStop) : calculateSize(zoom);
            acc[type] = {
                size,
                anchor: [size / 2, size / 2]
            };
            return acc;
        }, {} as MapIconConfigs);
    }
}

export enum MarkerType {
    stop = 'stop',
    stopFavorite = 'stopFavorite',
    stopSelected = 'stopSelected',
    stopNode = 'stopNode',
    bus = 'bus',
    location = 'location',
    selectedLocation = 'selectedLocation'
}

export const SizeValuesMap = {
    [MarkerType.stop]: IconUtils.getStopIconSizeValues,
    [MarkerType.stopFavorite]: IconUtils.getFavoriteStopIconSizeValues,
    [MarkerType.location]: IconUtils.getLocationIconSizeValues,
    [MarkerType.bus]: IconUtils.getBusIconSizeValues,
    [MarkerType.stopNode]: IconUtils.getStopNodeIconSizeValues,
    [MarkerType.stopSelected]: (zoom: number, isFavorite = false) => {
        const baseCalculator = isFavorite ? SizeValuesMap[MarkerType.stopFavorite] : SizeValuesMap[MarkerType.stop];
        return baseCalculator(zoom) * SELECTED_MARKER_SCALE;
    },
    [MarkerType.selectedLocation]: (zoom: number) => SizeValuesMap[MarkerType.location](zoom) * SELECTED_MARKER_SCALE
};
